import React from 'react';
import { SlideOverType, useSlideOverStore } from 'src/store/slide-over';
import { functionNoop } from 'src/utils/function/noop';
import SlideOverBase, { SlideOverBaseProps } from './base';
import { useSlideOverShowOnboarding } from './show-onboarding-hook';

interface Props extends Omit<SlideOverBaseProps, 'onOuterAreaClicked'> {
  type: SlideOverType;
  onBeforeClose?: () => Promise<void>;
}

/**
 *
 * @param props `onBeforeClose` performs checks and actions before close and close if successful,
 * while `type` determines whether a slideover should be active depending on which type is set
 * within the `SlideOverStore` so that no 2 slideovers can exists at the same time
 * @returns SlideOver of type
 */
const SlideOver = ({ type, onBeforeClose, open, onClose, ...rest }: Props) => {
  const slideOverType = useSlideOverStore((state) => state.slideOverType);
  const isSlideoverOpen = useSlideOverStore((state) => state.isSlideOverOpen);
  const closeSlideOver = useSlideOverStore((state) => state.closeSlideOver);
  useSlideOverShowOnboarding(isSlideoverOpen);

  const performClose = () => {
    closeSlideOver();
    onClose();
  };

  // TODO implement further
  const onSlideOverClose = () => {
    if (onBeforeClose) {
      onBeforeClose().then(performClose).catch(functionNoop);
    } else {
      performClose();
    }
  };

  if (slideOverType !== type) {
    return null;
  }

  return (
    <SlideOverBase
      open={isSlideoverOpen && open}
      onClose={performClose}
      onOuterAreaClicked={onSlideOverClose}
      {...rest}
    />
  );
};

export default SlideOver;
